import { render, staticRenderFns } from "./component2.vue?vue&type=template&id=c1aa3ade&scoped=true&"
import script from "./component2.vue?vue&type=script&lang=js&"
export * from "./component2.vue?vue&type=script&lang=js&"
import style0 from "./component2.vue?vue&type=style&index=0&id=c1aa3ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1aa3ade",
  null
  
)

export default component.exports